// Traducciones para navegación - Español
export const navigationEs = {
  // Enlaces del navbar
  links: {
    home: 'Inicio',
    vehicles: 'Vehículos',
    buyDirect: 'Compra Directa',
    consignments: 'Consignaciones',
    financing: 'Financiamiento',
    weSearchForYou: 'Buscamos por ti',
    contact: 'Contactar',
    book: 'Agendar visita',
  },

  // Breadcrumbs
  breadcrumbs: {
    home: 'Inicio',
    vehicles: 'Vehículos',
    vehicleDetails: 'Detalles del vehículo',
    contact: 'Contacto',
    financing: 'Financiamiento',
    consignments: 'Consignaciones',
    buyDirect: 'Compra directa',
    weSearchForYou: 'Buscamos por ti',
  },

  // Botones
  buttons: {
    menu: 'Menú',
    close: 'Cerrar',
    back: 'Volver',
    home: 'Ir al inicio',
  },
};



